import { type FC, memo } from 'react';
import styles from './index.module.scss';
import { Dropdown, type DropDownProps } from 'antd';

interface OwnProps extends DropDownProps {}

const ParrotDropDown: FC<OwnProps> = ({ children, ...props }) => {
  return (
    <Dropdown placement="bottom" className={styles.parrot_popover} arrow={false} {...props}>
      {children}
    </Dropdown>
  );
};

export default memo(ParrotDropDown);
